import 'babel-polyfill';
import {SmartComponentManager} from "smart-component-js";
import DefaultCtrl from "./controllers/DefaultCtrl";
import FeedbackModalComponent from "./components/FeedbackModalComponent";
import VisualParallaxComponent from "./components/VisualParallaxComponent";
import AreaPersonaleCtrl from "./controllers/AreaPersonaleCtrl";
import CompletaDatiCtrl from "./controllers/CompletaDatiCtrl";
import GiocaCodiceCtrl from "./controllers/GiocaCodiceCtrl";
import $ from "jquery";
import '../less/mb-kids.less';


SmartComponentManager.registerComponents({
    DefaultCtrl,
    VisualParallaxComponent,
    FeedbackModalComponent,
    AreaPersonaleCtrl,
    CompletaDatiCtrl,
    GiocaCodiceCtrl

});

$(document).ready(() => {
    let $body = $('.mb-promo-kids-2019');
    SmartComponentManager.initComponentByName($body[0], $body.attr('component'));
});
